require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tous-les-vnements-sur-les-campus-1-12-0.json") })
        }
      }, "path---tous-les-vnements-sur-les-campus-1-12-0");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tous-les-vnements-sur-les-campus-1-12-0!./.cache/json/tous-les-vnements-sur-les-campus-1-12-0.json
// module id = 591
// module chunks = 231608221292675